/**
 * @generated SignedSource<<e003c77da820d7267cd2e18bda6e03e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserSelectedViewInput = {
  alias?: string | null | undefined;
  databaseId?: number | null | undefined;
};
export type UserSelectedViewMutation$variables = {
  input: UpdateUserSelectedViewInput;
};
export type UserSelectedViewMutation$data = {
  readonly updateUserSelectedView: {
    readonly selectedView: {
      readonly alias?: string;
      readonly databaseId?: number;
      readonly isCoerced?: boolean;
      readonly type?: string;
    } | null | undefined;
  };
};
export type UserSelectedViewMutation = {
  response: UserSelectedViewMutation$data;
  variables: UserSelectedViewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCoerced",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "type": "SelectedDatabaseView",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alias",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "type": "SelectedVirtualView",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSelectedViewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserSelectedViewPayload",
        "kind": "LinkedField",
        "name": "updateUserSelectedView",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "selectedView",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserSelectedViewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserSelectedViewPayload",
        "kind": "LinkedField",
        "name": "updateUserSelectedView",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "selectedView",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "edca1e4ed82e033b0ac56f3775300210",
    "id": null,
    "metadata": {},
    "name": "UserSelectedViewMutation",
    "operationKind": "mutation",
    "text": "mutation UserSelectedViewMutation(\n  $input: UpdateUserSelectedViewInput!\n) {\n  updateUserSelectedView(input: $input) {\n    selectedView {\n      __typename\n      ... on SelectedDatabaseView {\n        type\n        databaseId\n        isCoerced\n      }\n      ... on SelectedVirtualView {\n        alias\n        isCoerced\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c7bf57c31bead10ef0c8368c94848a18";

export default node;
